import { render, staticRenderFns } from "./upvote-question-button.vue?vue&type=template&id=af6de184"
import script from "./upvote-question-button.vue?vue&type=script&lang=js"
export * from "./upvote-question-button.vue?vue&type=script&lang=js"
import style0 from "./upvote-question-button.vue?vue&type=style&index=0&id=af6de184&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports